var video, video_par;

/* 원료 비디오 재생 */
function fnVideoPlay(e, st, event) {
  if (event) {
    event.preventDefault();
  }
  video = document.getElementById(e);
  video.play();

  video_par = document.getElementById(e).closest(".vod_area");
  const playElement = video_par.querySelector(".play");
  const stopElement = video_par.querySelector(".stop");

  playElement.style.opacity = "0";
  setTimeout(() => {
    playElement.style.display = "none";
  }, 300);

  if (st) {
    stopElement.style.display = "none";
  } else {
    stopElement.style.opacity = "0";
    stopElement.style.display = "block";
    setTimeout(() => {
      stopElement.style.opacity = "1";
    }, 10);
  }
}

/* 원료 비디오 정지 */
function fnVideoStop(e, st, event) {
  if (event) {
    event.preventDefault();
  }
  video = document.getElementById(e);
  video.pause();
  //video.currentTime = 1;

  video_par = document.getElementById(e).closest(".vod_area");
  const playElement = video_par.querySelector(".play");
  const stopElement = video_par.querySelector(".stop");

  // fadeIn 효과를 위한 CSS transition 사용
  playElement.style.removeProperty("display");
  playElement.style.opacity = "0";
  setTimeout(() => {
    playElement.style.opacity = "1";
  }, 10);

  if (st) {
    stopElement.style.removeProperty("display");
  } else {
    stopElement.style.opacity = "0";
    setTimeout(() => {
      stopElement.style.display = "none";
    }, 300);
  }
}

/* 원료 탭 동작  */
document.addEventListener("click", function (e) {
  if (e.target.matches(".history_type li a")) {
    e.preventDefault();
    const clickedLink = e.target;
    const parentLi = clickedLink.parentElement;
    const tabIndex = Array.from(parentLi.parentElement.children).indexOf(
      parentLi,
    );

    document.querySelectorAll(".history_type li a").forEach((link) => {
      link.classList.remove("on");
    });
    clickedLink.classList.add("on");

    document
      .querySelectorAll(".history_type .img_wrap .tab_con")
      .forEach((content) => {
        content.style.display = "none";
      });
    const targetContent = document.querySelectorAll(
      ".history_type .img_wrap .tab_con",
    )[tabIndex];
    if (targetContent) {
      targetContent.style.display = "block";
    }
  }
});

/* 원료 배경색 변경 */
function updateIngredientsBackground() {
  const ingredientsCon = document.querySelector(".ingredients_con");
  if (ingredientsCon) {
    const ingredientsConT = ingredientsCon.offsetTop; // 원료컨텐츠 시작위치
    const ingredientsConH = ingredientsCon.offsetHeight; // 원료컨텐츠 높이
    const ingredientsConLeng = document.querySelectorAll(
      ".ingredients_con .conmid",
    ).length; // 원료컨텐츠 갯수

    if (
      window.scrollY > ingredientsConT &&
      window.scrollY < ingredientsConT + ingredientsConH
    ) {
      for (let i = 1; i <= ingredientsConLeng; i++) {
        const conmidElements = document.querySelectorAll(
          ".ingredients_con .conmid",
        );
        if (conmidElements[i - 1]) {
          if (window.scrollY > conmidElements[i - 1].offsetTop - 300) {
            // 모든 배경 클래스 제거하고 기본 클래스만 추가
            ingredientsCon.className = "ingredients_con";
            ingredientsCon.classList.add("bg_type" + i);
          }
        }
      }
    }
  }
}

window.addEventListener("scroll", updateIngredientsBackground);
document.addEventListener("DOMContentLoaded", updateIngredientsBackground);
